var React = require('react');

function BerninoRightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5158 6.46419L7.6918 0.992188H6.3158L9.9318 6.01619L0.299805 5.95219V7.04019L9.9318 6.97619L6.3318 12.0002H7.67581L11.5158 6.46419Z","fill":"black"}));
}

BerninoRightArrow.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = BerninoRightArrow;

BerninoRightArrow.default = BerninoRightArrow;
